import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import JqxLoader from "jqwidgets-scripts/jqwidgets-react-tsx/jqxloader";
import Button from "@material-ui/core/Button";
import * as Util from "../../utils/util.js";
import BasicBackBoard from "../../components/BasicBackBoard.js";

const nullCheck = (text) => {
  if (text === "null") return "";
  else return text;
};

function Menu99() {
  const inputRef = useRef([]);
  const myLoader = useRef();

  useEffect(() => {
    inputRef.current[0].value = window.sessionStorage.getItem("workplace_nm");
    inputRef.current[1].value = window.sessionStorage.getItem("user_id");
    inputRef.current[4].value = nullCheck(
      window.sessionStorage.getItem("user_name")
    );
    inputRef.current[5].value = nullCheck(
      window.sessionStorage.getItem("tel_no")
    );
    inputRef.current[6].value = nullCheck(
      window.sessionStorage.getItem("e_mail")
    );
  }, []);

  const saveBtnOnClick = () => {
    myLoader.current.open();

    if (inputRef.current[2].value === inputRef.current[3].value) {
      let form = new FormData();
      form.append("isOutSider", Util.isOutsider());
      form.append("userId", inputRef.current[1].value);
      form.append("pass", inputRef.current[2].value);
      form.append("name", inputRef.current[4].value);
      form.append("telNo", inputRef.current[5].value);
      form.append("eMail", inputRef.current[6].value);

      axios
        .post(Util.getBaseUrl() + "/Menu99/modify", form)
        .then((response) => {
          if (response.data.code === "0") {
            myLoader.current.close();
            alert("저장 완료 되었습니다.");
          } else {
            alert(response.data.message, myLoader.current.close());
          }
        })
        .catch((e) => {
          myLoader.current.close();
        });
    } else {
      alert(
        "비밀번호가 일치하지 않습니다.\n다시 확인해주세요",
        myLoader.current.close()
      );
    }
  };

  return (
    <div style={{ width: "110mm", height: "100%" }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <BasicBackBoard>
          <div style={{ flex: "0 0 auto" }}>
            <div style={{ height: "100%" }}>
              <div
                style={{
                  margin: 10,
                  marginLeft: 23,
                }}
              >
                거래처
                <input
                  ref={(el) => (inputRef.current[0] = el)}
                  disabled
                  style={{
                    marginLeft: 5,
                    height: 20,
                    width: 300,
                    border: "1px solid #aaa",
                  }}
                />
              </div>
              <div
                style={{
                  margin: 10,
                  marginLeft: 23,
                }}
              >
                아이디
                <input
                  disabled
                  ref={(el) => (inputRef.current[1] = el)}
                  style={{
                    marginLeft: 5,
                    height: 20,
                    width: 200,
                    border: "1px solid #aaa",
                  }}
                />
              </div>
              <div
                style={{
                  margin: 10,
                }}
              >
                비밀번호
                <input
                  ref={(el) => (inputRef.current[2] = el)}
                  type={"password"}
                  style={{
                    marginLeft: 5,
                    height: 20,
                    width: 120,
                    border: "1px solid #aaa",
                  }}
                />
                <span
                  style={{
                    margin: 10,
                  }}
                >
                  재확인
                  <input
                    ref={(el) => (inputRef.current[3] = el)}
                    type={"password"}
                    style={{
                      marginLeft: 5,
                      height: 20,
                      width: 120,
                      border: "1px solid #aaa",
                    }}
                  />
                </span>
              </div>
              <div
                style={{
                  margin: 10,
                  marginLeft: 36,
                }}
              >
                성명
                <input
                  ref={(el) => (inputRef.current[4] = el)}
                  style={{
                    marginLeft: 5,
                    height: 20,
                    width: 120,
                    border: "1px solid #aaa",
                  }}
                />
                <span
                  style={{
                    margin: 10,
                  }}
                >
                  휴대폰
                  <input
                    ref={(el) => (inputRef.current[5] = el)}
                    style={{
                      marginLeft: 5,
                      height: 20,
                      width: 120,
                      border: "1px solid #aaa",
                    }}
                  />
                </span>
              </div>
              <div
                style={{
                  margin: 10,
                  marginLeft: 23,
                }}
              >
                이메일
                <input
                  ref={(el) => (inputRef.current[6] = el)}
                  style={{
                    marginLeft: 5,
                    height: 20,
                    width: 295,
                    border: "1px solid #aaa",
                  }}
                />
              </div>
              <br />
              <div style={{ textAlign: "center", width: "380px" }}>
                <Button
                  className="d-btn primary"
                  onClick={() => saveBtnOnClick()}
                  variant="contained"
                >
                  저장
                </Button>
              </div>
              <JqxLoader
                ref={myLoader}
                width={100}
                height={60}
                isModal={true}
                imagePosition={"top"}
              />
            </div>
          </div>
        </BasicBackBoard>
      </div>
    </div>
  );
}

export default React.memo(Menu99);
